import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PizarraEvento } from 'src/common/pizarraEvento';
import { ContenidoStatus } from "src/common/contenido";

@Injectable()
export class PizarraService {

	private readonly PIZARRA_EVENTOS_URL: string = environment.backendUrl + '/pizarra';
	private readonly PIZARRA_STATUS_URL: string = this.PIZARRA_EVENTOS_URL + '/status';
	private readonly LAST_QTY_PARAM: string = 'qty';


	constructor( private http: HttpClient ) {};

	findLastEventos( qty: number ): Observable<PizarraEvento[]> {
		let params: HttpParams = new HttpParams().set( this.LAST_QTY_PARAM, qty.toString() );
		return this.http.get<PizarraEvento[]>( this.PIZARRA_EVENTOS_URL, { params } );
	};

	findPizarraStatus( qty: number ): Observable<ContenidoStatus> {
		let params: HttpParams = new HttpParams().set( this.LAST_QTY_PARAM, qty.toString() );
		return this.http.get<ContenidoStatus>( this.PIZARRA_STATUS_URL, { params } );
	};
};